import { createFactoryAction } from './utils'; // eslint-disable-next-line import/prefer-default-export

export var evaluateFacts = createFactoryAction('EVALUATE_FACTS', function (facts, parameters, includeInputValues, evaluateTimeoutMs) {
  return {
    makeRequest: function makeRequest(state, _ref) {
      var FactorySDK = _ref.FactorySDK;
      return FactorySDK.evaluateFactsV1({
        facts: facts,
        parameters: parameters,
        includeInputValues: includeInputValues,
        evaluateTimeoutMs: evaluateTimeoutMs
      });
    },
    meta: {
      facts: facts
    }
  };
});